import { faIdCard, faToggleOn } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/usePortal'

import { PortalModel } from '@models/types'

const generateTabBarItems = (portal: PortalModel) => {
  const urls = generateUrls(portal)
  const { editPortalRelationsUrl, editPortalUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editPortalUrl,
      key: 'details',
      title: portal?.title || 'Portal Details',
    },
    {
      icon: faToggleOn,
      href: editPortalRelationsUrl,
      key: 'relations',
      title: 'Relations',
    },
  ]
}

export default generateTabBarItems
